import React from "react";
import styles from "./details.module.css";
import Navbar from "../../Components/Navbar/Navbar";
import { Col, Container, Row } from "react-bootstrap";
import {
  Heading,
  Paragraph,
} from "../../Components/TextComponents/TextComponents";

const Techdetails = () => {
  return (
    <React.Fragment>
      <div className={styles.main_section}>
        <Navbar />

        <Container>
          <Row>
            <Col md={6} sm={12}>
              <div className={styles.heroSection}>
                <Heading color="#fff">
                  Bringing the Future of Energy Efficiency to India
                </Heading>
                <Paragraph color="#fff">
                  Energy efficiency is no longer an option—it is a necessity. As
                  businesses seek to reduce costs and carbon footprints,
                  CrossBorder BTC has partnered with Enover to bring EHP
                  Technology to India.
                </Paragraph>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* ---------section---------- */}
      <Container>
        <div className={styles.section}>
          <Row>
            <Col md={7} sm={12}>
              <Heading>About the Partnership</Heading>
              <Paragraph color="#62677A">
                A Joint Vision for a Sustainable Future
              </Paragraph>
            </Col>
            <Col md={5} sm={12}>
              <Paragraph>
                CrossBorder BTC and Enover have come together to transform
                India's energy landscape. By leveraging EHP Technologies, we
                provide cutting-edge solutions for industrial heating, cooling,
                and renewable energy integration—helping Indian businesses
                reduce operational costs while adopting sustainable practices.
              </Paragraph>
            </Col>
          </Row>
          <img
            loading="lazy"
            src="/images/projectdetails/bg_second.png"
            alt="bg"
          />
        </div>
      </Container>
      {/* ---------section-end--------- */}
      {/* -------EHP-TECH_START-------------- */}
      <Container>
        <Row className="my-5">
          <Col sm={12} md={6}>
            <div className={styles.left_section}>
              <Heading>What is EHP Technology?</Heading>
              <Paragraph color="#62677A">
                A 5th-Generation Heat Transfer Breakthrough
              </Paragraph>
              <p>
                EHP (Energy Heat Pump) Technology is an advanced heat transfer
                and waste heat recovery system that maximizes energy efficiency
                across industries. It is designed to reduce energy consumption
                by up to 100%, significantly lowering carbon emissions and
                energy costs.
                <br />
                <br />
                With patented technology and a proven track record in Europe and
                the Middle East, EHP now enters the Indian market through this
                joint venture, helping businesses move towards a greener future.
              </p>

              <img src="/images/projectdetails/section_2.png" alt="section" />
            </div>
          </Col>
          <Col sm={12} md={6}>
            <div className={styles.right_section}>
              <img src="/images/projectdetails/section_1.png" alt="section" />
            </div>
          </Col>
        </Row>
      </Container>
      {/* -------EHP-END-------------- */}

      {/* -------BenfitsSection-start------------- */}
      <Container>
        <div className={styles.benfit}>
          <Heading>Key Benefits for Indian Businesses</Heading>
          <Paragraph color="#62677A">
            Efficiency, Sustainability & Cost Savings
          </Paragraph>
          <div className={styles.info}>
            <div className={styles.box}>
              <h6>Waste Heat Recovery & Decarbonization</h6>
              <p>
                Captures and reuses up to 61% of wasted heat in industries,
                reducing energy loss and operational costs.
              </p>
            </div>
            <div className={styles.box}>
              <h6>Next-Gen Heating & Cooling Systems</h6>
              <p>
                Panel Radiators & Underfloor Heating: Save up to 67% on energy
                costs in residential and commercial spaces.
              </p>
              <p>
                Solar PVT Integration: Increases electricity production by 28%,
                ensuring higher efficiency.
              </p>
              <p>
                Heat Pumps & Chilled Beams: Boosts energy efficiency while
                lowering operational expenses.
              </p>
            </div>
            <div className={styles.box}>
              <h6>Smart Infrastructure & Renewable Energy</h6>
              <p>
                Seamlessly integrates with district heating, district cooling,
                and geothermal systems, optimizing urban energy consumption.
              </p>
            </div>
          </div>
        </div>
      </Container>
      {/* -------BenfitsSection-end------------- */}
      {/* ---------section---------- */}
      <Container>
        <div className={styles.section}>
          <Row>
            <Col md={7} sm={12}>
              <Heading>Why This Matters for India?</Heading>
              <Paragraph color="#62677A">
                Aligning with India’s Green Energy Goals
              </Paragraph>
            </Col>
            <Col md={5} sm={12}>
              <Paragraph>
                As India pushes towards net-zero emissions by 2070, businesses
                are under pressure to adopt energy-efficient and sustainable
                solutions. Our JV with Enover brings a proven European
                technology to Indian industries, ensuring they stay competitive
                while contributing to India’s clean energy mission.
                <br />
                <br />
                With EHP Technology, companies across manufacturing, real
                estate, automotive, and infrastructure sectors can significantly
                cut down energy costs and reduce environmental impact.
              </Paragraph>
            </Col>
          </Row>
          <img
            loading="lazy"
            src="/images/projectdetails/last_bg.png"
            alt="bg"
          />
        </div>
      </Container>
      {/* ---------section-end--------- */}
    </React.Fragment>
  );
};

export default Techdetails;
